import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getProductCartApi = createAsyncThunk(
  "addProductInCart",
  async () => {
    const response = await axiosInstance.get("/getCart");
    return response.data;
  }
);

const getProductCartSlice = createSlice({
  name: "addProductInCart",
  initialState: {
    data: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductCartApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductCartApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getProductCartApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default getProductCartSlice.reducer;
